import './styles.sass';

import React from 'react';
import { truncate } from 'lodash-es';
import { Link } from 'react-router-dom';

import PublicationStatusFlags from 'components/Shared/PublicationStatusFlags';
import ResearchOutput from 'components/Explorer/models/research_output';
import TopItemList from 'components/Highlights/TopItemList';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';
import useNavigateParams from 'hooks/useNavigateParams';

const TopOutputs = () => {
  const params = useQueryParams();
  const navigateParams = useNavigateParams();

  const { data, loading } = useExplorerData('highlights/top_outputs', params, {
    reloadOn: ['filters']
  });

  const openDetailsPage = (event, output) => {
    event.preventDefault();
    Analytics.trackEvent('highlights-open-details-page', { outputId: output.id });
    navigateParams(QueryParams.withShowDetails(params, output.id));
  };

  const trackJumpLink = () => {
    Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'top-outputs' });
  };

  return (
    <div className="Highlights-TopOutputs Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.TopOutputs.title')}</h2>

      <div className="Highlights-content-wrapper">
        {(loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS) && (
          <div key="loadingMessage" className="Highlights-loading-message" />
        )}
        {loading === Loading.ERROR && (
          <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>
        )}
        {loading === Loading.EMPTY_RESPONSE && (
          <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.TopOutputs.empty')}</div>
        )}
        {loading === Loading.SUCCESS && (
          <div key="content" className="Highlights-content Highlights-TopOutputs-content">
            <TopItemList>
              {data.map((row) => {
                const output = new ResearchOutput(row);
                return (
                  <TopItemList.Item key={output.id}>
                    <img
                      className="Highlights-TopOutputs-Badge"
                      src={`https://api.altmetric.com/v1/donut/${output.id}_64.png`}
                      alt={`Altmetric score ${output.score}`}
                      width="64"
                      height="64"
                    />
                    <div>
                      <a
                        href={`https://www.altmetric.com/details/${output.id}`}
                        className="Highlights-TopOutputs-link"
                        onClick={(event) => openDetailsPage(event, output)}
                      >
                        <PublicationStatusFlags output={output} />
                        {truncate(output.title, { length: 120, separator: /\W/ })}
                      </a>
                      <div className="Highlights-TopOutputs-meta">{output.meta}</div>
                      {params.filters.timeframe && params.filters.timeframe !== 'at' && (
                        <span className="Highlights-TopOutputs-mentions">
                          {I18n.htmlSafe('Explorer.Highlights.TopOutputs.mentions_' + params.filters.timeframe, {
                            count: output.total_mentions
                          })}
                        </span>
                      )}
                    </div>
                  </TopItemList.Item>
                );
              })}
            </TopItemList>
            <Link
              onClick={trackJumpLink}
              to={QueryParams.locationFor(params, '/outputs')}
              className="Highlights-jump-link"
              aria-label={
                I18n.t('Explorer.Highlights.TopOutputs.title') + ' — ' + I18n.t('Explorer.Highlights.TopOutputs.more')
              }
            >
              {I18n.t('Explorer.Highlights.TopOutputs.more')}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopOutputs;
